var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user_dashboard_calendar"},[_c('b-datepicker',{attrs:{"inline":"","events":_vm.events,"size":"is-small"},on:{"input":_vm.dateChanged,"change-month":_vm.monthChanged,"change-year":_vm.yearChanged},model:{value:(_vm.jsDate),callback:function ($$v) {_vm.jsDate=$$v},expression:"jsDate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }